import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MemorialService } from 'administrativo-lib';
import { ProdutoService } from 'almoxarifado-lib';
import { CriterioReducaoMemorial, EddyAutoComplete, FuncaoService, Licitacao, LicitacaoPipe, Login, Memorial, Produto, ProdutoUnidade } from 'eddydata-lib';
import { Alignment, Workbook } from 'exceljs';
import { ConfirmationService } from 'primeng/api';
import { AutoComplete } from 'primeng/autocomplete';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'app-memorial',
  templateUrl: './memorial.component.html'
})
export class MemorialComponent implements OnInit, OnDestroy {

  public imaskQtd = {
    mask: Number,
    scale: 0,
    signed: false
  };
  public imaskConfig = {
    mask: Number,
    scale: 4,
    signed: true,
    thousandsSeparator: '.',
    padFractionalZeros: true,
    normalizeZeros: true,
    radix: ','
  };

  public produtoAutoComplete: EddyAutoComplete<Produto>;
  public itemAnterior: Memorial;
  public itemAtual: Memorial;
  public produtoAtual: Produto;
  public criteriosReducao: { id: CriterioReducaoMemorial, nome: string }[];
  public reducaoCriterioGlobal: CriterioReducaoMemorial = 'V';
  public reducaoLanceGlobal: number = 0;
  public marcado: boolean = true;

  @ViewChild('produto_item_') campoItem: AutoComplete;
  @ViewChild('nome_lote_') campoLote: ElementRef;
  @ViewChild('quantidade_') campoQtde: ElementRef;
  @ViewChild('descricao_') campoDescricao: ElementRef;
  @ViewChild('reducao_') campoReducao: ElementRef;
  @ViewChild('btnAdicionar') public btnAdicionar: ElementRef;
  @ViewChild('btnAdicionarLote') public btnAdicionarLote: ElementRef;

  @Input() edicao: boolean = true; // variavel para definir se opções de edições estarão disponiveis
  @Input() pregao: boolean = false; // variavel para definir se a chamada veio da tela de pregao
  @Input() entidade: Licitacao;
  @Input() login: Login;

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected confirmationService: ConfirmationService,
    public funcaoService: FuncaoService,
    protected memorialService: MemorialService,
    protected produtoService: ProdutoService,
  ) { }

  ngOnInit(): void {
    this.produtoAutoComplete = new EddyAutoComplete(null, this.produtoService,
      'id', ['codigo', 'nome'], { orderBy: 'codigo,nome', relations: 'unidades.unidade' }, { number: ['codigo'], text: ['codigo', 'nome'] }
    );
    this.criteriosReducao = [{ id: 'V', nome: '$' }, { id: 'P', nome: '%' },];
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  @HostListener('window:keydown.control.i', ['$event'])
  public adicionarItem(event: KeyboardEvent) {
    event.preventDefault();
    this.adicionar(false);
  }

  @HostListener('window:keydown.control.l', ['$event'])
  public adicionarLote(event: KeyboardEvent) {
    event.preventDefault();
    this.adicionar(true);
  }

  @HostListener('window:keydown.control.p', ['$event'])
  public abrirConsultaProduto(event: KeyboardEvent) {
    event.preventDefault();
    $('#dialogProdutoUnBusca').modal('show');
  }

  private adicionar(lote: boolean) {
    if (!this.edicao) return;
    if (this.entidade.itens && this.entidade.itens.find((itm) => { return itm.editavel === true })) {
      toastr.info('Finalize a edição atual antes de incluir outro item');
      return;
    }

    this.itemAnterior = undefined;
    this.itemAtual = new Memorial();
    this.itemAtual.editavel = true;
    this.itemAtual.lote = lote;
    this.itemAtual.reducao_criterio = 'V';
    this.itemAtual.reducao_lance = 0;
    this.produtoAtual = undefined;
    if (lote) {
      this.itemAtual.quantidade = 0;
    }

    if (!this.entidade.itens || this.entidade.itens.length === 0) {
      this.entidade.itens = [];
      this.itemAtual.ordem = 1;
    } else {
      this.itemAtual.ordem = (this.entidade.itens[this.entidade.itens.length - 1].ordem) + 1;
    }
    this.itemAtual.ordem_julgamento = this.itemAtual.ordem;

    this.entidade.itens.unshift(this.itemAtual);
    this.btnAdicionar.nativeElement.disabled = true;
    this.btnAdicionarLote.nativeElement.disabled = true;
    this.focarItem();
  }

  public editar(item: Memorial) {
    if (!this.edicao) return;
    if (this.entidade.itens && this.entidade.itens.find((itm) => { return itm.editavel === true || itm.editavelDescricao === true || itm.editavelReducao === true })) {
      toastr.info('Finalize a edição atual antes de editar outro item');
      return;
    }

    this.itemAnterior = Object.assign({}, item);
    this.itemAtual = item;
    this.itemAtual.editavel = true;
    this.itemAtual.lote = !new Boolean(item.produto_unidade).valueOf();
    item.lote = this.itemAtual.lote;
    if (!item.lote) {
      this.itemAtual.produto_unidade = item.produto_unidade;
      this.produtoService.obter({ id: this.itemAtual.produto_unidade.produto.id, relations: 'unidades.unidade' }).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.produtoAtual = res;
          this.selecionarUnidade();
          this.focarItem();
        });
    }
    this.btnAdicionar.nativeElement.disabled = true;
    this.btnAdicionarLote.nativeElement.disabled = true;
  }

  public salvar(item: Memorial) {
    if (!this.edicao) return;
    try {
      if (item.lote) {
        if (!item.descricao) {
          throw new Error('Informe a descrição do lote!');
        }
        if (!item.unidade) {
          throw new Error('Informe a unidade do lote!');
        }
        if (this.entidade.itens.find(m => m.descricao === item.descricao && m !== item)) {
          this.itemAtual.descricao = undefined;
          this.itemAtual.unidade = undefined;
          throw new Error('Lote já incluído neste processo!');
        }

        item.quantidade = 1;
      } else {
        if (!this.produtoAtual || !item.produto_unidade) {
          throw new Error('Informe o produto/serviço e a unidade!');
        }
        if (!item.quantidade || +item.quantidade <= 0) {
          throw new Error('Informe a quantidade!');
        }
        if (this.entidade.itens.filter(m => m.produto_unidade !== undefined)
          .find(m => m.produto_unidade.id === item.produto_unidade.id && m !== item)) {
          this.itemAtual.produto_unidade = undefined;
          this.itemAtual.quantidade = undefined;
          throw new Error('Item já incluído neste processo!');
        }

        delete this.produtoAtual.unidades;
        item.produto_unidade.produto = this.produtoAtual;
        item.descricao = this.produtoAtual.descricao;
        item.unidade = item.produto_unidade.unidade.nome;
      }

      this.itemAtual.editavel = false;
      this.itemAtual = undefined;
      this.itemAnterior = undefined;
      this.btnAdicionar.nativeElement.disabled = false;
      this.btnAdicionarLote.nativeElement.disabled = false;
      this.ordenarItens();

      if (!this.entidade.id) {
        this.adicionar(item.lote)
      }
    } catch (e) {
      toastr.warning(e, 'Validação');
      throw e;
    }
  }

  public cancelar(item: Memorial, index: number) {
    if (!this.edicao) return;
    this.itemAtual = Object.assign({}, this.itemAnterior);

    if (!this.itemAtual) {
      this.entidade.itens.splice(index, 1);
    } else if (!item.id && item.lote && !this.itemAtual.descricao && !this.itemAtual.unidade) {
      this.entidade.itens.splice(index, 1);
    } else if (!item.id && !item.lote && !this.itemAtual.quantidade && !this.itemAtual.produto_unidade) {
      this.entidade.itens.splice(index, 1);
    } else {
      if (!item.lote && this.produtoAtual) {
        delete this.produtoAtual.unidades;
        item.produto_unidade.produto = this.produtoAtual;
      }
      item.editavel = false;
    }
    this.itemAtual = undefined;
    this.itemAnterior = undefined;
    this.btnAdicionar.nativeElement.disabled = false;
    this.btnAdicionarLote.nativeElement.disabled = false;
  }

  public remover(item: Memorial, index: number) {
    if (!this.edicao) return;
    if (item.id) {
      this.confirmationService.confirm({
        message: 'Deseja realmente remover o item?',
        header: 'Exclusão',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Confirmar',
        rejectLabel: 'Cancelar',
        accept: () => {
          this.memorialService.remover(item.id).pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
              toastr.info('Registro removido com sucesso!', 'Exclusão');
              this.entidade.itens.splice(index, 1);
              this.atualizarOrdem();
              this.btnAdicionar.nativeElement.disabled = false;
              this.btnAdicionarLote.nativeElement.disabled = false;
            }, (err) => toastr.error(err.error.payload));
        }
      });
    } else {
      this.entidade.itens.splice(index, 1);
      this.atualizarOrdem();
      this.btnAdicionar.nativeElement.disabled = false;
      this.btnAdicionarLote.nativeElement.disabled = false;
    }
  }

  public alterarDescricao(item: Memorial) {
    if (!this.edicao) return;
    if (this.entidade.itens && this.entidade.itens.find((itm) => { return itm.editavel === true || itm.editavelDescricao === true || itm.editavelReducao === true })) {
      toastr.info('Finalize a edição atual antes de editar outro item');
      return;
    }

    if (!item.produto_unidade) {
      this.editar(item)
    } else {
      item.editavelDescricao = true;
      setTimeout(() => this.campoDescricao ? this.campoDescricao.nativeElement.focus() : null, 500);
    }
  }

  public salvarDescricao(item: Memorial) {
    if (!this.edicao) return;
    item.descricao = item.descricao.trim();
    item.editavelDescricao = false;
  }

  public alterarReducao(item: Memorial) {
    if (!this.edicao) return;
    if (this.entidade.itens && this.entidade.itens.find((itm) => { return itm.editavel === true || itm.editavelDescricao === true || itm.editavelReducao === true })) {
      toastr.info('Finalize a edição atual antes de editar outro item');
      return;
    }

    item.editavelReducao = true;
    setTimeout(() => this.campoReducao ? this.campoReducao.nativeElement.select() : null, 500);
  }

  public salvarReducao(item: Memorial) {
    if (!this.edicao) return;
    item.editavelReducao = false;
  }

  public salvarReducaoGlobal() {
    if (!this.edicao) return;
    this.entidade.itens.forEach(item => {
      item.reducao_lance = this.reducaoLanceGlobal;
      item.reducao_criterio = this.reducaoCriterioGlobal;
    });
  }

  public ordenarItens() {
    if (!this.edicao) return;
    this.entidade.itens.sort((a, b) => { return a.ordem - b.ordem });
  }

  public atualizarOrdem() {
    if (!this.edicao) return;
    this.ordenarItens();
    let ordem = 0;
    this.entidade.itens.forEach((m) => {
      m.ordem = ++ordem;
      m.ordem_julgamento = m.ordem;
    })
  }

  private focarItem() {
    if (!this.edicao) return;
    if (this.itemAtual) {
      if (this.itemAtual.lote) {
        setTimeout(() => this.campoLote ? this.campoLote.nativeElement.focus() : null, 500);
      } else {
        setTimeout(() => this.campoItem ? this.campoItem.focusInput() : null, 500);
      }
    }
  }

  public selecionarUnidade() {
    if (!this.edicao) return;
    if (this.itemAtual && this.produtoAtual?.unidades) {
      if (this.itemAtual.unidade) {
        this.itemAtual.produto_unidade = this.produtoAtual.unidades.find((un) => un.unidade.nome === this.itemAtual.unidade);
      } else {
        this.itemAtual.produto_unidade = this.produtoAtual.unidades[0];
      }
    }
  }

  compareFn(c1: any, c2: any): boolean {
    if (c1 && c2) {
      if (c1.id && c2.id) {
        return c1.id === c2.id;
      } else if (c1.chave && c2.chave) {
        return c1.chave == c2.chave;
      } else {
        return c1 === c2;
      }
    } else {
      return false;
    }
  }

  public drop(event: CdkDragDrop<string[]>) {
    if (!this.edicao && !this.pregao) return;
    moveItemInArray(this.entidade.itens, event.previousIndex, event.currentIndex);
    let ordem = 0;
    this.entidade.itens.forEach((m) => {
      if (this.pregao) {
        m.ordem_julgamento = ++ordem;
      } else {
        m.ordem = ++ordem;
      }
    });
  }

  public abrirItens(item: Memorial) {
    this.itemAtual = item;
    $('#dialogMemorialItem').modal('show');
  }

  public callbackProdutoUn(prodUn: ProdutoUnidade) {
    if (!this.edicao) return;
    if (this.itemAtual && !this.itemAtual.lote) {
      this.itemAtual.produto_unidade = prodUn
      this.produtoService.obter({ id: this.itemAtual.produto_unidade.produto.id, relations: 'unidades.unidade' }).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          this.produtoAtual = res;
          setTimeout(() => this.campoQtde ? this.campoQtde.nativeElement.focus() : null, 500);
        });
    }
  }

  public async exportarMapaPreco() {
    if (!this.entidade.id) return;
    const algCenter: Partial<Alignment> = { vertical: 'middle', horizontal: 'center' };
    const algRight: Partial<Alignment> = { vertical: 'middle', horizontal: 'right' };

    const wb = new Workbook();
    wb.creator = this.login.usuario.nome;
    wb.lastModifiedBy = this.login.usuario.nome;
    wb.created = new Date();
    wb.modified = new Date();
    wb.calcProperties.fullCalcOnLoad = true;

    const ws = wb.addWorksheet('Memorial', { views: [{ state: 'frozen', xSplit: 0, ySplit: 4, activeCell: 'E5' }] });

    ws.columns = [
      { key: 'item', width: 5, alignment: algCenter, protection: { locked: true } },
      { key: 'unidade', width: 10, alignment: algCenter, protection: { locked: true } },
      { key: 'quantidade', width: 7, alignment: algRight, protection: { locked: true } },
      { key: 'descricao', width: 80, alignment: { vertical: 'middle', horizontal: 'left' }, protection: { locked: true } },
      { key: 'marca', width: 30, alignment: { vertical: 'middle', horizontal: 'left' } },
      { key: 'valor', width: 12, alignment: algRight },
      { key: 'total', width: 12, alignment: algRight, protection: { locked: true } }
    ];

    ws.getCell('A1').value = 'Código:';
    ws.getCell('A1').alignment = algCenter;
    ws.mergeCells('A1:B1');

    ws.getCell('C1').value = this.entidade.id;
    ws.getCell('C1').alignment = algCenter;

    ws.getCell('D1').value = 'ARQUIVO DE MAPA DE PREÇOS PARA PREENCHIMENTO DE PROPOSTA ESCRITA';
    ws.getCell('D1').alignment = algCenter;
    ws.getCell('D1').font = { bold: true, size: 16 };
    ws.mergeCells('D1:G1');

    ws.getCell('A2').value = 'Documento';
    ws.getCell('A2').alignment = algCenter;
    ws.getCell('A2').font = { bold: true, size: 12 };
    ws.mergeCells('A2:C2');

    ws.getCell('D2').value = this.login.orgao.nome + ' - ' + this.login.cidade.nome;
    ws.getCell('D2').alignment = algCenter;
    ws.getCell('D2').font = { bold: true, size: 12 };
    ws.mergeCells('D2:G2');

    ws.getCell('A3').value = 'Informe o Documento';
    ws.getCell('A3').alignment = algCenter;
    ws.getCell('A3').protection = { locked: false };
    ws.getCell(`A3`).numFmt = '[<=9999]0000;[>=999999999999]00"."000"."000"/"0000-00;000"."000"."000-00';
    ws.getCell('A3').font = { size: 12 };
    ws.mergeCells('A3:C3');

    ws.getCell('D3').value = `Divisão de Licitações e Compras - PROCESSO ADMINISTRATIVO Nº: ${this.entidade.processo} - ${this.entidade.modalidade.nome} Nº: ${new LicitacaoPipe().transform(this.entidade.numero)}`;
    ws.getCell('D3').alignment = algCenter;
    ws.getCell('D3').font = { bold: true, size: 12 };
    ws.mergeCells('D3:G3');

    ws.getRow(4).values = ['Item', 'Und.', 'Qtde', 'Descrição', 'Marca', 'Valor Unit.', 'Total'];
    ws.getRow(4).alignment = algCenter;
    ws.getRow(4).font = { bold: true };

    let linha = 5;
    this.entidade.itens.forEach((item) => {
      ws.getRow(linha);

      ws.getCell(`A${linha}`).value = item.ordem;
      ws.getCell(`A${linha}`).alignment = algCenter;

      ws.getCell(`B${linha}`).value = item.unidade;
      ws.getCell(`B${linha}`).alignment = algCenter;

      ws.getCell(`C${linha}`).value = item.quantidade;
      ws.getCell(`C${linha}`).alignment = algCenter;

      ws.getCell(`D${linha}`).value = item.descricao;
      ws.getCell(`D${linha}`).alignment = { wrapText: true }

      ws.getCell(`E${linha}`).alignment = algCenter;
      ws.getCell(`E${linha}`).protection = { locked: false };

      ws.getCell(`F${linha}`).alignment = algRight;
      ws.getCell(`F${linha}`).numFmt = '#,##0.0000;[Red]\-#,##0.0000';
      ws.getCell(`F${linha}`).protection = { locked: false };
      ws.getCell(`F${linha}`).dataValidation = {
        type: 'decimal',
        operator: 'lessThanOrEqual',
        allowBlank: true,
        showInputMessage: true,
        formulae: [0],
        promptTitle: 'Valor Inválido!',
        prompt: 'O valor informado deve ser positivo'
      };

      ws.getCell(`G${linha}`).value = { formula: `C${linha} * F${linha}`, date1904: true };
      ws.getCell(`G${linha}`).alignment = algRight;
      ws.getCell(`G${linha}`).numFmt = '#,##0.0000;[Red]\-#,##0.0000';

      linha++;
    })

    await ws.protect('842d51933523ffbcdd1836e7d4a9323ff8b9cdd183', {});

    wb.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      const downloadURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = `mapa-precos_${this.entidade.numero}.xlsx`;
      link.target = '_blank';
      link.click();
      window.URL.revokeObjectURL(downloadURL);
    })
  }

  public toggleSelecionado() {
    // marcado === false marcado
    // marcado === true desmarcado
    this.entidade.itens.forEach(m => m.selecionado = !this.marcado)
  }
}
